import api from "@/services/api";

const { get, post } = api.getPrefixedMethods("prompt-tuning");

export const promptTuningTriage = {
  list(params = {}) {
    return get(`triage/`, { params });
  },
  summary() {
    return get(`triage/summary/`);
  },
  mark(id, body) {
    return post(`triage/${id}/mark/`, body);
  },
  bulkMark(body) {
    return post(`triage/bulk-mark/`, body);
  },
  sendToAutotune(body) {
    return post(`triage/send-to-autotune/`, body);
  },
};

export const promptTuningProposals = {
  list(params = {}) {
    return get(`proposals/`, { params });
  },
  detail(id) {
    return get(`proposals/${id}/`);
  },
  edit(id, body) {
    return post(`proposals/${id}/edit/`, body);
  },
  resolveConflict(id, idx, body) {
    return post(`proposals/${id}/conflicts/${idx}/resolve/`, body);
  },
  revalidate(id) {
    return post(`proposals/${id}/revalidate/`);
  },
  waiveRow(id, feedbackId, body) {
    return post(`proposals/${id}/rows/${feedbackId}/waive/`, body);
  },
  approve(id, body = {}) {
    return post(`proposals/${id}/approve/`, body);
  },
  reject(id, body) {
    return post(`proposals/${id}/reject/`, body);
  },
};
